export async function publishEnterpriseBookingUseCase(repository, booking) {
  return await repository.publish(booking);
}
